module.exports = __webpack_public_path__ + "img/31_21.c1fae785.png";